import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import { getOptimizedImage } from "utils/optimizeContentfulImage"
import "./section-roadmap-v2.scss"

const SectionRoadmapV2 = ({
  callsToAction,
  roadmapHeading,
  roadmapSteps,
  title,
}) => {
  return (
    <section className="section-roadmap-v2">
      <div className="container-v2">
        <div className="section-roadmap-v2--heading-wrapper">
          {title && (
            <h2 className="section-roadmap-v2--heading">
              <TextLockupV2>{title}</TextLockupV2>
            </h2>
          )}
          {roadmapHeading?.heading && (
            <h3 className="section-roadmap-v2--heading-text">
              {roadmapHeading.heading}
            </h3>
          )}
        </div>
        <div className="section-roadmap-v2--step-header"></div>
        {roadmapSteps && roadmapSteps?.length && roadmapSteps?.length > 0 && (
          <div className="section-roadmap-v2--steps">
            {roadmapSteps.map((step, index) => (
              <div className="section-roadmap-v2--step" key={step.id}>
                <div className="section-roadmap-v2--step-media-wrapper">
                  <div className="section-roadmap-v2--step-media-wrapper-inner">
                    <div className="section-roadmap-v2--step-image-wrapper">
                      {step.image && (
                        <Image
                          alt={step.title}
                          className="section-roadmap-v2--step-image"
                          image={step.image.fluid}
                        />
                      )}
                      {step.icon && (
                        <img
                          alt={step.title}
                          className="section-roadmap-v2--step-icon"
                          src={getOptimizedImage(step.icon.file.url, 'iconLarge')}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="section-roadmap-v2--step-content">
                  <div className="section-roadmap-v2--step-content-inner">
                    <h4 className="section-roadmap-v2--step-title">
                      {index + 1}. {step.title}
                    </h4>

                    {step.text && (
                      <div
                        className="section-roadmap-v2--step-text"
                        dangerouslySetInnerHTML={{
                          __html: step.text.childrenMarkdownRemark[0].html,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {callsToAction &&
          callsToAction?.length &&
          callsToAction?.length > 0 && (
            <div className="section-roadmap-v2--calls-to-action">
              {callsToAction.map(action => (
                <ButtonV2
                  accessibilityLabel={action.accessibilityLabel}
                  className={getButtonClasses(
                    action.buttonStyle || "primary-green",
                    action.buttonSize || "large"
                  )}
                  href={action.path}
                  key={action.id}
                  text={action.text}
                />
              ))}
            </div>
          )}
      </div>
    </section>
  )
}

export default SectionRoadmapV2
SectionRoadmapV2.propTypes = {
  callsToAction: PropTypes.array.isRequired,
  roadmapHeading: PropTypes.string.isRequired,
  roadmapSteps: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
}
